import {useParams} from 'react-router-dom';
import {Playlist} from '@app/web-player/playlists/playlist';
import {useInfiniteData} from '@common/ui/infinite-scroll/use-infinite-data';

export type ArtistPlaylistCreditRole = 'all' | 'primary' | 'secondary';

export function useArtistPlaylists(
  artistId?: string | number,
  options: {artistCreditRole?: ArtistPlaylistCreditRole} = {},
) {
  const {artistId: routeArtistId} = useParams<{artistId: string}>();
  const id = artistId ?? (routeArtistId ? Number(routeArtistId) : undefined);

  return useInfiniteData<Playlist>({
    endpoint: `artists/${id}/playlists`,
    queryKey: ['artists', +id!, 'playlists', options],
    queryParams: {
      artistCreditRole: options.artistCreditRole || 'all',
    },
    defaultOrderBy: 'updated_at',
    defaultOrderDir: 'desc',
  });
}
